import { Modal } from "antd";
import React from "react";
import styles from "./index.module.scss";
import { Button } from "app/(new-pages)/components/Button/pc/index.pc";
import SingpassButton from "../SingpassButton";
import { setCookie } from "helpers/cookies";
const ConfirmInformation = ({ open = false, onClose, loading, handleSubmit, dic, data }) => {
  const isSuccess = !!data?.id;
  const handleClose = () => {
    const time = new Date(Date.now() + 3 * 24 * 60 * 60 * 1000);
    setCookie("singpassDolater", "1", time);
    onClose();
  };

  return (
    <Modal
      open={open}
      footer={null}
      width={600}
      onCancel={onClose}
      maskClosable={false}
      centered
      title={
        isSuccess ? (
          dic?.confirmYourInformation
        ) : (
          <>
            {WarnSvg} {dic?.verificationFailed}
          </>
        )
      }
      wrapClassName={styles.wrapClassNameModal}
    >
      {!isSuccess && <p className={styles.tryLater}>{dic?.myInfoIsCurrentlyUnavailable}</p>}
      <div className={styles.content}>
        <div className={styles.nameBox}>
          <div className={styles.name}>{dic?.NRIC}</div>
          <div className={styles.name}>{dic?.principalName}</div>
          <div className={styles.name}>{dic?.residentialStatus}</div>
          <div className={styles.name}>{dic?.nationality}</div>
          <div className={styles.name}>{dic?.passType}</div>
          <div className={styles.name}>{dic?.passStatus}</div>
          <div className={styles.name}>{dic?.passExpiryDate}</div>
        </div>
        {isSuccess ? (
          <div className={styles.detailsBox}>
            <div className={styles.details}>{data?.uinfin || "-"}</div>
            <div className={styles.details}>{data?.name || "-"}</div>
            <div className={styles.details}>{data?.residential_status || "-"}</div>
            <div className={styles.details}>{data?.nationality || "-"}</div>
            <div className={styles.details}>{data?.pass_type || "-"}</div>
            <div className={styles.details}>{data?.pass_status || "-"}</div>
            <div className={styles.details}>{data?.pass_expiry_date || "-"}</div>
          </div>
        ) : (
          <div className={styles.detailsBox}>
            {Array(7)
              .fill(null)
              .map((_, index) => (
                <div key={index} className={styles.details}>
                  <span> {dic?.failed}</span>
                </div>
              ))}
          </div>
        )}
      </div>

      <p className={styles.tips}>{dic?.specialReminder}</p>

      <div className={styles.footer}>
        {isSuccess ? (
          <Button variant='primaryBtn' btnSize='size40' loading={loading} onClick={handleSubmit}>
            {dic?.submit}
          </Button>
        ) : (
          <>
            <Button
              variant='whiteBoxShadowBtn'
              btnSize='size40'
              onClick={handleClose}
              style={{ flex: 1 }}
            >
              {dic?.doItLater}
            </Button>
            <SingpassButton onClose={onClose}></SingpassButton>
          </>
        )}
      </div>
    </Modal>
  );
};

export default ConfirmInformation;

const WarnSvg = (
  <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'>
    <path
      d='M9.99976 1.66699C14.6021 1.66699 18.3337 5.39763 18.3337 10C18.3337 14.6024 14.6021 18.333 9.99976 18.333C5.39761 18.3327 1.66675 14.6022 1.66675 10C1.66675 5.39779 5.39761 1.66726 9.99976 1.66699ZM9.16675 12.9463V14.6123H10.8337V12.9463H9.16675ZM9.16772 5V11.667H10.8347V5H9.16772Z'
      fill='#FF9000'
    />
  </svg>
);
